import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Close = ({ onClick }) => (
    <button className="modal-want-to-leave-close font-accent" onClick={onClick}>
        <span className="modal-want-to-leave-close-button">&times;</span>
    </button>
);

Close.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default Close;
